import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { UserStore } from '@cxc/core/services';

export const loggedGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (userStore.get().logged) {
    return true;
  }

  router.navigateByUrl('/');

  return false;
};
